module.exports = __webpack_public_path__ + "static/media/no_image_gochi_kid_poor.b0fa3cfc.png";